export default __webpack_public_path__ + "static/media/login-watch.74972a23.png";